const accountLogin = {
  init: () => {
    const SHOW_PASSWORD_CLASS = 'show-password'

    const refs = {
      containerEl: document.querySelector('.js-account-password-container'),
      buttonEl: document.querySelector('.js-account-password-button'),
      inputEl: document.querySelector('.js-account-password-input')
    }

    // Only proceed if all required DOM elements exist.
    if (Object.values(refs).some((el) => !el)) return

    const actions = {
      togglePasswordVisibility: () => {
        console.log('togglePasswordVisibility')
        if(refs.containerEl.classList.contains(SHOW_PASSWORD_CLASS)) {
          refs.containerEl.classList.remove(SHOW_PASSWORD_CLASS)
          refs.inputEl.type = 'password'
        } else {
          refs.containerEl.classList.add(SHOW_PASSWORD_CLASS)
          refs.inputEl.type = 'text'
        }
      }
    }

    refs.buttonEl.addEventListener('click', actions.togglePasswordVisibility)
  }
}
export default accountLogin;
